import { useTheme } from '@mui/material/styles';

// Lightweight native <input> for dense rate matrices. MUI's TextField renders
// ~6 DOM nodes each (FormControl + OutlinedInput + fieldset + legend …); a
// 60-slab × 5-zone × 17-col grid would mount thousands of them and freeze the
// browser. The v6 HTML uses raw <input> for exactly this reason — so do we.
// Uncontrolled (defaultValue + onBlur) to avoid re-render storms while typing.
export default function CellInput({ value, onCommit, type = 'number', width = 50, align = 'right', ...rest }) {
  const theme = useTheme();
  return (
    <input
      type={type}
      defaultValue={value}
      onBlur={(e) => onCommit(e.target.value)}
      style={{
        width,
        boxSizing: 'border-box',
        textAlign: align,
        fontFamily: 'JetBrains Mono, monospace',
        fontSize: 11.5,
        padding: '3px 5px',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 5,
        outline: 'none',
        background: '#fff',
        color: theme.palette.text.primary,
      }}
      onFocus={(e) => { e.target.style.borderColor = theme.palette.primary.main; }}
      onBlurCapture={(e) => { e.target.style.borderColor = theme.palette.divider; }}
      {...rest}
    />
  );
}
